import { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import {NgModule} from '@angular/core';
import {StepChapterComponent} from '../step/step.chapter.component';
import {EinstiegComponent} from './einstieg/einstieg.component';
import {EingabeStepComponent} from './eingabe/eingabe.step.component';
import {PortalService} from '../services/portal.service';
import {AdvisorPagenotfoundComponent} from "../advisor.pagenotfound.component";
import {ErgebnisComponent} from "./ergebnis/ergebnis.component";


declare let focPath: string;

/**
 * ignore massnahmen in nav when we are in path elektromobilitaet
 */
function ignoreNavForElektromobility() {
   return  window['focPath'] && window['focPath'] === 'elektro';
}

/**
 * ignore elektro mobility nav when we are not in path elektromobilitaet
 */
function ignoreNavForNotElektromobility() {
  return  window['focPath'] &&  window['focPath'] === 'bau';
}

/**
 * Routes for the foerdermittelcheck.
 * The default route leads to foerdermittelcheck here
 */
const routes: Routes = [
  { path: ':portalId/foerdermittelcheck', children: [  // default step is 'einstieg'
      { path: '', redirectTo: 'einstieg', pathMatch: 'full' },
      // list of all available steps in the advisor
      { path: 'einstieg', component: EinstiegComponent},
      // first input section
      { path: 'eingabe', component: StepChapterComponent, children: [

          {path: 'foerdernehmer/basisinformationen/1', component: EingabeStepComponent, data: {swipeCount: '1'}},
          {path: 'foerdernehmer/basisinformationen/2', component: EingabeStepComponent, data: {swipeCount: '2'}},

          {path: 'gebaeude/basisinformationen/3', component: EingabeStepComponent, data: {swipeCount: '10'}},
          {path: 'gebaeude/basisinformationen/4', component: EingabeStepComponent, data: {swipeCount: '11'}},
          {path: 'gebaeude/basisinformationen/5', component: EingabeStepComponent, data: {swipeCount: '12'}},
          {path: 'gebaeude/basisinformationen/6', component: EingabeStepComponent, data: {swipeCount: '13'}},

          {path: 'nutzung/basisinformationen/7', component: EingabeStepComponent, data: {ignoreInNav: ignoreNavForElektromobility, swipeCount: '20'}},

          {path: 'massnahmen/insulation', component: EingabeStepComponent, data: {ignoreInNav: ignoreNavForElektromobility, swipeCount: '30'}},
          {path: 'massnahmen/heating', component: EingabeStepComponent, data: {ignoreInNav: ignoreNavForElektromobility, swipeCount: '31'}},
          {path: 'massnahmen/solar_thermal_energy', component: EingabeStepComponent, data: {ignoreInNav: ignoreNavForElektromobility, swipeCount: '32'}},
          {path: 'massnahmen/refrigeration_system', component: EingabeStepComponent, data: {ignoreInNav: ignoreNavForElektromobility, swipeCount: '33'}},

          {path: 'zusatzmassnahmen/heating_optimization', component: EingabeStepComponent, data: {ignoreInNav: ignoreNavForElektromobility, swipeCount: '40'}},
          {path: 'zusatzmassnahmen/additional_systems', component: EingabeStepComponent, data: {ignoreInNav: ignoreNavForElektromobility, swipeCount: '41'}},
          {path: 'zusatzmassnahmen/additional_measures', component: EingabeStepComponent, data: {ignoreInNav: ignoreNavForElektromobility, swipeCount: '42'}},

          {path: 'energie/energetic_optimization', component: EingabeStepComponent, data: {ignoreInNav: ignoreNavForElektromobility,  swipeCount: '50'}},
          {path: 'energie/energy_efficiency', component: EingabeStepComponent, data: {ignoreInNav: ignoreNavForElektromobility, swipeCount: '51'}},
          {path: 'energie/electric_mobility', component: EingabeStepComponent, data: {ignoreInNav: ignoreNavForNotElektromobility, swipeCount: '52'}},

          { path: '', redirectTo: 'foerdernehmer/basisinformationen/1', pathMatch: 'full' },
        ]},

      { path: 'ergebnis', component: StepChapterComponent, children: [
          { path: 'foerdermittel', component: ErgebnisComponent, data: {swipeCount: '1000', advisor: 'foerdermittelcheck'}},
          { path: '', redirectTo: 'foerdermittel', pathMatch: 'full' },
      ]},
  ]},
  {path: ':portalId', redirectTo: PortalService.defaultPortal + '/foerdermittelcheck', pathMatch: 'full'},
  {path: 'foerdermittelcheck/', redirectTo: PortalService.defaultPortal + '/foerdermittelcheck', pathMatch: 'full'},
  {path: '', redirectTo: PortalService.defaultPortal + '/foerdermittelcheck', pathMatch: 'full'},
  {path: '**', pathMatch: 'full', component: AdvisorPagenotfoundComponent, data: {advisor: 'foerdermittelcheck'}}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollOffset: [0, 150],
    paramsInheritanceStrategy: 'always'
})],
  exports: [RouterModule]
})
export class FoerdermittelcheckRoutingModule { }
